import { UserContestCollaborationWhitelistResultAjax } from './user-contest-collaboration-whitelist.backend-model';
import { UserContestCollaborationWhitelist } from './user-contest-collaboration-whitelist.model';

export function transformUserContestCollaborationWhitelist(
  resultAjax: UserContestCollaborationWhitelistResultAjax,
  authUid: string,
): UserContestCollaborationWhitelist {
  return {
    id: authUid,
    isWhitelist: resultAjax.contestCollaborationWhitelistedUser,
  };
}
